'use strict';

var React = require('react');

var SvgPageReferenceMinor = function SvgPageReferenceMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.5 5.75c0-.69.56-1.25 1.25-1.25h2.75v3.25c0 .966.784 1.75 1.75 1.75h3.25v1.25a.75.75 0 0 0 1.5 0v-2a.75.75 0 0 0-.22-.53l-5-5a.75.75 0 0 0-.53-.22h-3.5a2.75 2.75 0 0 0-2.75 2.75v8.5a2.75 2.75 0 0 0 2.75 2.75h3.25a.75.75 0 0 0 0-1.5h-3.25c-.69 0-1.25-.56-1.25-1.25v-8.5Zm7.94 2.25-2.44-2.44v2.19c0 .138.112.25.25.25h2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.22 17.28a.75.75 0 0 0 1.06-1.06l-1.97-1.97h.94a.75.75 0 0 0 0-1.5h-2.75a.75.75 0 0 0-.75.75v2.75a.75.75 0 0 0 1.5 0v-.94l1.97 1.97Z"
  }));
};
SvgPageReferenceMinor.displayName = "PageReferenceMinor";

exports.SvgPageReferenceMinor = SvgPageReferenceMinor;
